export default __webpack_public_path__ + "static/media/Cleaning-Equipment-mob.9f0b5a5f.jpg";